var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row-min-space"},[_c('b-form-group',{class:{
            'required-field': false,
        },attrs:{"label":_vm.field.label,"label-for":("id_" + (_vm.field._id))}},[_c('div',{staticClass:"row profile-setup"},[_c('div',{staticClass:"col-md-5 mb-20 dialling-code-field"},[_c('isd-code',{directives:[{name:"validate",rawName:"v-validate",value:({
                        required: false,
                    }),expression:"{\n                        required: false,\n                    }"}],class:{
                        'is-invalid': _vm.errors.has('Dialing Code'),
                    },attrs:{"data-segment-id":_vm.dataSegmentId,"field":{
                        association: 'countries',
                        type: 'isd-code',
                        isLocked: true,
                        isRequired: false,
                        label: 'Dialing code',
                        placeholder: 'Dialing code',
                        options: [],
                        key: 'contactInfo.isdCode',
                    },"text-field":"isdCodeTitle","value-field":"isdCode","multiple":false,"name":"Dialing Code"}})],1),_c('div',{staticClass:"col-md-7"},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:({
                        required: _vm.field.isRequired,
                        max: 10,
                        min: 10,
                        regex: /^([0-9]*)$/,
                    }),expression:"{\n                        required: field.isRequired,\n                        max: 10,\n                        min: 10,\n                        regex: /^([0-9]*)$/,\n                    }"}],class:{
                        'is-invalid': _vm.errors.has('phone number'),
                    },attrs:{"type":"number","placeholder":"Enter phone number","data-vv-name":"phone number"},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})],1)])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }